import axios from '@/utils/axios';
import urlConfig from '@/utils/urlConfig';


export default {



  // 创建应用
  createAppApi: (data) => axios.apiPost(urlConfig.userURL + '/app/create', data),
  //修改应用
  updateAppApi: (data) => axios.apiPost(urlConfig.userURL + '/app/update', data),
  refreshSecretApi: (data) => axios.apiPost(urlConfig.userURL + '/app/refreshSecret?appId='+ data.appId),
  //获取应用详情
  getAppDetailApi: (data) => axios.apiPost(urlConfig.userURL + '/app/get?appId=' + data.appId),
  //获取应用列表
  getAppListApi: (data) => axios.apiPost(urlConfig.userURL + '/app/list', data),
  //删除应用
  deleteAppApi: (data) => axios.apiPost(urlConfig.userURL + '/app/delete', data),

  // 添加密钥
  rotateKeyApi: (data) => axios.apiPost(urlConfig.userURL + '/app/rotateKey?appId=' + data.appId),

  //接口权限管理
  //添加接口权限
  addAppApi: (data) => axios.apiPost(urlConfig.userURL + '/app/addApi', data),
  //获取接口权限列表
  getAppApiListApi: (data) => axios.apiPost(urlConfig.userURL + '/app/listApi?appId='+ data.appId),
  //删除接口权限
  deleAppPathApi: (data) => axios.apiPost(urlConfig.userURL + '/app/deleteApi?appId='+data.appId+'&apiPath='+ data.apiPath),


  //获取接口权限列表
  getCoreUrlpi: () => axios.apiGet(urlConfig.userURL + '/core/url/list'),





};
 